import { render, staticRenderFns } from "./SynPlatformSetting.vue?vue&type=template&id=5f132fe3&scoped=true&"
import script from "./SynPlatformSetting.vue?vue&type=script&lang=js&"
export * from "./SynPlatformSetting.vue?vue&type=script&lang=js&"
import style0 from "./SynPlatformSetting.vue?vue&type=style&index=0&id=5f132fe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f132fe3",
  null
  
)

export default component.exports